import importer from 'common/importer'
const { deloitReq: req } = importer('APIs', null)

export const saveContactForm = (formData) => {
  return req.post('/case/service-request', formData)
}

export const getAppLatestVersion = () => {
  return req.get('users/site/mobile-versions')
}
